import { render } from "./SideMenu1.vue?vue&type=template&id=c0fb446a"
import script from "./SideMenu1.vue?vue&type=script&lang=js"
export * from "./SideMenu1.vue?vue&type=script&lang=js"

import "./SideMenu1.vue?vue&type=style&index=0&id=c0fb446a&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__